import React from 'react';

export enum CheckboxTheme {
  Blue = `blue`,
}

export interface CheckboxProps {
  checked?: boolean;
  checkedColor?: string;
  theme?: string;
  checkedIcon?: string;
  disabled?: boolean;
  focused?: boolean;
  icon?: string;
  uncheckedIcon?: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onPointerEnter?: React.PointerEventHandler<HTMLDivElement>;
  onPointerLeave?: React.PointerEventHandler<HTMLDivElement>;
  elref?: any;
  id?: string;
  'data-testid'?: string;
}
